import { render, staticRenderFns } from "./BaseMenuOptions.vue?vue&type=template&id=59bb5d98&scoped=true&"
import script from "./BaseMenuOptions.vue?vue&type=script&lang=js&"
export * from "./BaseMenuOptions.vue?vue&type=script&lang=js&"
import style0 from "./BaseMenuOptions.vue?vue&type=style&index=0&id=59bb5d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb5d98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VList,VListItem,VMenu,VTooltip})
